import React, {Component} from 'react';
import './index.scss';
import * as messages from '../../shared/messages';

class Message extends Component {

  hideErrorPopupMessages = () => {
    this.props.clearMessages();
  }

  componentDidUpdate(prevProps) {
    if ((this.props.successMessage && this.props.successMessage
        !== prevProps.successMessage)
        || (this.props.errorMessage && this.props.errorMessage
            !== prevProps.errorMessage)) {
      setTimeout(() => {
        this.hideErrorPopupMessages()
      }, 10000);
    }
  }

  render() {
    return (
        <div>
          {
            (this.props.successMessage || this.props.errorMessage) ? (
                this.props.errorMessage ?
                    (
                        <div className="message-alert message-alert-error">
                          {this.props.errorMessage === messages.GENERIC_ERROR
                              ? (<div>{messages.GENERIC_ERROR_PART1} <a
                                  href={messages.GENERIC_ERROR_SUPPORT_URL}
                                  target="_blank">{messages.GENERIC_ERROR_PART2}</a>
                              </div>)
                              : this.props.errorMessage}
                          <i onClick={this.hideErrorPopupMessages}
                             className="close"/>
                        </div>
                    ) : (
                        <div className="message-alert message-alert-success">
                          {this.props.successMessage} <i
                            onClick={this.hideErrorPopupMessages}
                            className="close"/>
                        </div>
                    )
            ) : (
                null
            )
          }
        </div>
    );
  }

}

export default Message;


// WEBPACK FOOTER //
// ./src/components/Message/index.js